module.exports = __webpack_public_path__ + "dataanalysestatic/img/biaogan.746c738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/biaogan.png
// module id = i1Pm
// module chunks = 37